import React, { ReactNode } from 'react';

export enum Alignment {
  FlexStart    = 'flex-start',
  FlexEnd      = 'flex-end',
  Center       = 'center',
  SpaceBetween = 'space-between',
  SpaceAround  = 'space-around',
  Baseline     = 'baseline',
  Stretch      = 'stretch',
}

export enum Direction {
  Column        = 'column',
  ColumnReverse = 'column-reverse',
  Row           = 'row',
  RowReverse    = 'row-reverse',
}

export enum Wrap {
  NoWrap      = 'nowrap',
  // eslint-disable-next-line no-shadow
  Wrap        = 'wrap',
  WrapReverse = 'wrap-reverse',
}

interface IFlex {
  align?: Alignment;
  children: ReactNode;
  direction?: Direction;
  grow?: number;
  justify?: Alignment;
  order?: number;
  shrink?: number;
  isolation?: 'isolate' | 'auto'
  type?: 'div' | 'label' | 'section' | 'span';
  wrap?: Wrap;
}

const Flex = ({
  children,
  type: Wrapper = 'div',
  direction = Direction.Row,
  wrap = Wrap.NoWrap,
  justify,
  align,
  grow,
  shrink,
  order,
  isolation,
}: IFlex) => (
  <Wrapper
    children={children}
    style={{
      display: 'flex',
      flexDirection: direction,
      flexWrap: wrap,
      justifyContent: justify,
      alignItems: align,
      flexGrow: grow,
      flexShrink: shrink,
      isolation,
      order,
    }}
  />
);

export default Flex;
